import type { Product } from 'BrokerTsLib/src/enums'

export const Apps = {
  vehicle: 1,
  leasing: 2,
  leasingSimplifiedWizard: 3,
  property: 4,
  travel: 5,
  extra: 6,
  shortInsurance: 7, // denni pov
  fleet: 8,
  publicPoleas: 9,
} as const

export type Apps = typeof Apps[keyof typeof Apps]

export function getAppString(app?: Apps | null): string | undefined {
  return app ? Object.keys(Apps).find(key => Apps[key as keyof typeof Apps] === app) : undefined
}

export interface IApp {
  name: string
  app: Apps
  icon: string
  iconSize?: number
  path?: string
  product: Product
  /** Zda se zobrazuje jako samostatná aplikace tj. má položku v menu, aktuality atd. */
  standalone?: boolean // NOTE: Možná by to šlo nahradit tím, že by jedna aplikace měla více produktů
}